import { applyStyles, any } from './utils';
import defaults from './defaults';
var Content = /** @class */ (function () {
    function Content(component) {
        this.component = component;
        this.scrollableContent = component.node.querySelector('.awsui-app-layout__content--scrollable');
    }
    Content.prototype.getMaxWidth = function () {
        var _a;
        return _a = this.component.maxContentWidth, (_a !== null && _a !== void 0 ? _a : defaults.get(this.component).maxContentWidth);
    };
    Content.prototype.getMinWidth = function () {
        var _a;
        return _a = this.component.minContentWidth, (_a !== null && _a !== void 0 ? _a : defaults.get(this.component).minContentWidth);
    };
    Content.prototype.getScrollableContentStyles = function () {
        var maxWidth = this.getMaxWidth();
        var minWidth = this.getMinWidth();
        return {
            minWidth: isFinite(minWidth) ? minWidth : null,
            maxWidth: isFinite(maxWidth) ? maxWidth : null
        };
    };
    Content.prototype.update = function (isMobile) {
        return any([applyStyles(this.scrollableContent, this.getScrollableContentStyles())]);
    };
    return Content;
}());
export default Content;
//# sourceMappingURL=content.js.map